import { useContext } from 'react'

import { AppContext } from '../App'

const Version = () => {
  const { state } = useContext(AppContext)

  return (
    <div className='fixed z-30 bottom-0 left-0 mb-4 ml-4 text-xs p-2 rounded-[10] bg-slateDark'>
      Version: {state.version}
    </div>
  )
}

export { Version }
